module.exports = "/images/Fun Center.svg?94128b87f8b90802fd0d48d46a9515a5";